// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3f72a0c7","488":"a6868323","977":"3803f959"}[chunkId] + ".chunk.js";
};